import { FC } from "react";
import { useRemoveFromCart } from "../hooks/useCart";
import { CartItemMoreInfo } from "./CartItemMoreInfo";
import { useCalcPriceQuery } from "../api/queries/priceQueries";
import { mappingBookingState2RequestDTO } from "../mapping/mappingBookingState2RequestDTO";
import { useMoney } from "../hooks/useMoney";
import { usePopup } from "../hooks/usePopup";
import { OkCancelPopup } from "./modal/OkCancelPopup";
import { icQuestion } from "./image/image-src";
import { useTranslation } from "react-i18next";

export const CartItemRows: FC<{
  cartItems: BookingState[];
}> = ({ cartItems }) => {
  const { t } = useTranslation();
  const { formatMoney } = useMoney();
  const bookingPrice = useCalcPriceQuery(
    cartItems.map((x) => mappingBookingState2RequestDTO(x)),
  );
  const removeFromCart = useRemoveFromCart();
  const popupDel = usePopup<BookingState>({
    onOk: (card) => card && removeFromCart.mutate([card]),
  });
  return (
    <>
      <div className="custom-scroll-bar !mr-0 max-h-[min(40.875rem,60vh)] overflow-y-auto px-[1.125rem]">
        {cartItems.map((card, index) => (
          <div
            key={card.id}
            className={`flex border-t border-[#DCDCDC] py-[1.5rem] ${
              index === 0 && "border-none"
            }`}
          >
            <div className="mr-4 h-[5rem] w-[5rem] shrink-0 basis-[5rem]">
              <img
                className="size-[5rem] rounded-lg object-cover"
                src={card?.product?.thumbnail}
                alt={t(card?.product?.name ?? "")}
              />
            </div>
            <div className="mr-4 text-left">
              <p className="mb-1 text-sm font-semibold text-[#232323]">
                {t(card?.product?.name ?? "")}
              </p>
              <CartItemMoreInfo d={card} />
              <p className="text-base font-semibold text-[#007AFF]">
                {formatMoney(
                  bookingPrice?.data?.priceOfSingleBookings[index]?.cartTotal,
                )}
              </p>
            </div>
            <button
              type="button"
              className="wei-1 flex h-6 w-6 content-center justify-end"
              onClick={() => popupDel.open(card)}
            >
              <img className="h-6 w-6" src="../assets/icons/trash.svg" alt="" />
            </button>
          </div>
        ))}
      </div>
      {popupDel.isOpen && (
        <OkCancelPopup
          ic={icQuestion}
          title={t("Are you sure want to remove?")}
          onOk={() => popupDel.onOk()}
          onCancel={() => popupDel.close()}
          okText={t("Delete")}
        />
      )}
    </>
  );
};
